import * as tslib_1 from "tslib";
import React, { useRef, useContext, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { PerspectiveContext } from '../Context';
import StickyContent from './StickyContent';
import { useScrollAware } from '../utils/hooks/useScrollAware';
function getHeight(node) {
    if (!node) {
        return 0;
    }
    return node.getBoundingClientRect().height;
}
var Sticky = function (_a) {
    var _b = _a.bottomStop, bottomStop = _b === void 0 ? 0 : _b, _c = _a.marginTop, marginTop = _c === void 0 ? 0 : _c, contentProps = tslib_1.__rest(_a, ["bottomStop", "marginTop"]);
    var rootRef = useRef(null);
    var innerRef = useRef(null);
    var _d = useState(getHeight(innerRef.current)), minHeight = _d[0], setMinHeight = _d[1];
    var getZeroPerspectiveContainer = useContext(PerspectiveContext).getZeroPerspectiveContainer;
    var zeroPerspectiveContainer = getZeroPerspectiveContainer();
    var _e = useState(0), top = _e[0], setTop = _e[1];
    var checkIfStuck = useCallback(function () {
        if (!rootRef.current) {
            return false;
        }
        var rootRect = rootRef.current.getBoundingClientRect();
        return rootRect.top - marginTop <= 0;
    }, [marginTop]);
    var _f = useState(checkIfStuck()), isStuck = _f[0], setIsStuck = _f[1];
    var updateTop = useCallback(function (_a) {
        var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, bodyWidth = _a.bodyWidth;
        var isStuckNow = checkIfStuck();
        setIsStuck(isStuckNow);
        var height = minHeight || getHeight(innerRef.current);
        setMinHeight(height);
        if (zeroPerspectiveContainer && isStuckNow) {
            var bottom = typeof bottomStop === 'function' ? bottomStop(bodyWidth) : bottomStop;
            if (bottom !== 0) {
                var diff = scrollHeight - scrollTop - height - marginTop - bottom;
                setTop(diff < 0 ? diff : 0);
                return;
            }
        }
        setTop(0);
    }, [bottomStop, checkIfStuck, marginTop, minHeight, zeroPerspectiveContainer]);
    useScrollAware(updateTop);
    var content = (React.createElement(StickyContent, tslib_1.__assign({ isStuck: isStuck, top: top, marginTop: marginTop, ref: innerRef }, contentProps)));
    return (React.createElement("div", { ref: rootRef, style: { minHeight: minHeight } }, isStuck && !!zeroPerspectiveContainer
        ? ReactDOM.createPortal(content, zeroPerspectiveContainer)
        : content));
};
Sticky.displayName = 'Sticky';
export default Sticky;
//# sourceMappingURL=Sticky.js.map